





















import {Component, Emit, Model, Prop, Vue} from "vue-property-decorator";
import {LadingStore} from "@/modules/ladings/store";
import {Lading} from "@/interfaces/entity";
import {LadingParams} from "@/modules/ladings/params";
import debounce from "lodash/debounce";
import LadingLabel from "@/modules/ladings/List/components/Label.vue";

@Component({
    name: "LadingSelector",
    components: {LadingLabel}
})
export default class extends Vue {
    @Model("change")
    readonly ladingRowGuid!: string|string[];

    @Emit('change')
    handleChange(value: number) {
        return value;
    }

    @Prop({ default: "default", type: String })
    readonly mode!: string;

    @Prop({ type: Number })
    readonly status!: number;

    get ids() {
        const ladings = LadingStore.ladings;
        return ladings
            .filter((lading: Lading) => this.status ? lading.status === this.status : true)
            .map((lading: Lading) => lading.rowGuid);
    }

    async created() {
        try {
            if (!LadingStore.ids?.length)
                await LadingStore.listLading({ ...new LadingParams(), status: this.status });
        } catch (e) {
            this.$notification.error({ message: "Thất bại", description: e?.response?.data?.message || "Đã có lỗi xảy ra" });
        }
    }

    private onSearch = debounce((value: string) => {
        LadingStore.listLading({...new LadingParams(), search: value, status: this.status});
    }, 500);
}
